import { ERROR_CODES_SPO } from '../constants/http.constants';

export const GENERIC_ERROR = 'Er is iets fout gegaan. Probeer het later opnieuw';

export const ERROR_TEXTS = {
  DOSSIER_CREATE: GENERIC_ERROR,
  DOSSIER_STATUS_CHANGE: GENERIC_ERROR,
  DOSSIER_PRIVATE_MODE_CHANGE: 'Er is iets fout gegaan. Kan privémodus niet wijzigen',
  DOSSIER_DEADLINE_CHANGE: 'Er is iets fout gegaan. Kan volgende deadline niet wijzigen',
  DOSSIER_RELATE_DOSSIERS: GENERIC_ERROR,
  DOSSIER_REMOVE_RELATIONS: GENERIC_ERROR,
  ADD_CLARIFICATION: GENERIC_ERROR,
  UPDATE_CLARIFICATION: GENERIC_ERROR,
  APPROVE_CLARIFICATION: GENERIC_ERROR,
  DELETE_CLARIFICATION: 'Kan vraagverheldering niet verwijderen. Probeer het later opnieuw',
  ADD_CLARIFICATION_STAKEHOLDER: GENERIC_ERROR,
  UPDATE_CLARIFICATION_STAKEHOLDER: GENERIC_ERROR,
  REMOVE_CLARIFICATION_STAKEHOLDER: GENERIC_ERROR,
  ADD_CASETAFEL_STAKEHOLDER: GENERIC_ERROR,
  UPDATE_CASETAFEL_STAKEHOLDER: GENERIC_ERROR,
  REMOVE_CASETAFEL_STAKEHOLDER: GENERIC_ERROR,
  ADD_PROCEDURE_STAKEHOLDER: GENERIC_ERROR,
  UPDATE_PROCEDURE_STAKEHOLDER: GENERIC_ERROR,
  REMOVE_PROCEDURE_STAKEHOLDER: GENERIC_ERROR,
  ADD_CASETAFEL: GENERIC_ERROR,
  UPDATE_CASETAFEL: GENERIC_ERROR,
  APPROVE_CASETAFEL: GENERIC_ERROR,
  REJECT_CASETAFEL: GENERIC_ERROR,
  DELETE_CASETAFEL: 'Kan casetafel niet verwijderen. Probeer het later opnieuw',
  DELETE_ATTACHMENT: 'Kan bijlage niet verwijderen. Probeer het later opnieuw',
  UPDATE_ATTACHMENT: 'Kan niet updaten. Probeer het later opnieuw',
  UPLOAD_ATTACHMENT: 'Kan een bijlage niet uploaden. Probeer het later opnieuw',
  GET_FORM_BY_SLUG: GENERIC_ERROR,
  EXPORT_CASETAFEL_ANSWERS: GENERIC_ERROR,
  UPDATE_PROCEDURE: GENERIC_ERROR,
  UPDATE_OVERVIEW: GENERIC_ERROR,
  ADD_PROCEDURE_PART: GENERIC_ERROR,
  UPDATE_PROCEDURE_PART: GENERIC_ERROR,
  DELETE_PROCEDURE_PART: 'Kan onderdeel niet verwijderen. Probeer het later opnieuw',
  ADD_PROCEDURE_GOAL: GENERIC_ERROR,
  UPDATE_PROCEDURE_GOAL: GENERIC_ERROR,
  DELETE_PROCEDURE_GOAL: 'Kan doelstelling niet verwijderen. Probeer het later opnieuw',
  ADD_PROCEDURE_GOAL_INDICATOR: GENERIC_ERROR,
  UPDATE_PROCEDURE_GOAL_INDICATOR: GENERIC_ERROR,
  DELETE_PROCEDURE_GOAL_INDICATOR: 'Kan indicator niet verwijderen. Probeer het later opnieuw',
  ADD_INDICATOR_MEASURE_MOMENT: GENERIC_ERROR,
  UPDATE_INDICATOR_MEASURE_MOMENT: GENERIC_ERROR,
  DELETE_INDICATOR_MEASURE_MOMENT: 'Kan meetmoment niet verwijderen. Probeer het later opnieuw',
  ADD_COMMENT: 'Kan geen commentaar toevoegen. Probeer het later opnieuw',
  UPDATE_COMMENT: 'Kan geen commentaar aanpassen. Probeer het later opnieuw',
  DELETE_COMMENT: 'Kan geen commentaar verwijderen. Probeer het later opnieuw',
  PIN_COMMENT: 'Kan geen commentaar vastzetten. Probeer het later opnieuw',
  UNPIN_COMMENT: 'Kan geen commentaar losmaken. Probeer het later opnieuw',
  ADD_OFFERING: GENERIC_ERROR,
  UPDATE_OFFERING: GENERIC_ERROR,
  DELETE_OFFERING: 'Kan aanbod niet verwijderen. Probeer het later opnieuw',
  DELETE_OFFERING_IMAGE: 'Kan afbeelding niet verwijderen. Probeer het later opnieuw',
  ADD_OFFERING_IMAGE: GENERIC_ERROR,
  GET_ALL_THEMES: GENERIC_ERROR,
  ADD_THEME: GENERIC_ERROR,
  UPDATE_THEME: GENERIC_ERROR,
  REMOVE_THEME: 'Kan label niet verwijderen. Probeer het later opnieuw',
  GET_CONTACTS_WITHOUT_PARENTS: GENERIC_ERROR,
  ADD_CONTACT: GENERIC_ERROR,
  GET_CONTACTS: GENERIC_ERROR,
  CONTACT_WITH_EMAIL_EXISTS: 'Contact met dit e-mailadres bestaat al',
  CONTACT_WITH_NO_PERMISSION: 'U beschikt niet over de vereiste rechten',
  UPDATE_CONTACT: 'Contact kan niet worden geupdated',
  UPDATE_CONTACT_ROLE: 'Probleem met het aanpassen van de rollen van een contact',
  REMOVE_CONTACT: 'Kan contact niet verwijderen. Probeer het later opnieuw',
  ADD_SCHOOL: GENERIC_ERROR,
  DELETE_SCHOOL: 'Kan school niet verwijderen. Probeer het later opnieuw',
  UPDATE_SCHOOL: GENERIC_ERROR,
  ADD_BRANCH: GENERIC_ERROR,
  UPDATE_BRANCH: GENERIC_ERROR,
  DELETE_BRANCH: 'Kan vestiging niet verwijderen. Probeer het later opnieuw',
  UPDATE_AGODI_BRANCH: GENERIC_ERROR,
  GET_SCHOOL: GENERIC_ERROR,
  GET_BRANCH: GENERIC_ERROR,
  ADD_TEMPLATE: GENERIC_ERROR,
  UPDATE_TEMPLATE: GENERIC_ERROR,
  DELETE_TEMPLATE: GENERIC_ERROR,
  GET_TEMPLATES_FOR_CATEGORY: GENERIC_ERROR,
  DOSSIER_ASSIGNED_CHANGE: GENERIC_ERROR,
  ADD_PARTNER: GENERIC_ERROR,
  UPDATE_PARTNER: GENERIC_ERROR,
  REMOVE_PARTNER: GENERIC_ERROR,
  PARTNER_WITH_NAME_EXISTS: 'Partner met deze naam bestaat al',
  GET_ALL_PARTNERS: GENERIC_ERROR,
  ADD_CONTACTMOMENT: GENERIC_ERROR,
  UPDATE_CONTACTMOMENT: GENERIC_ERROR,
  REMOVE_CONTACTMOMENT: GENERIC_ERROR,
  ADD_CONTACTMOMENT_STAKEHOLDER: GENERIC_ERROR,
  UPDATE_CONTACTMOMENT_STAKEHOLDER: GENERIC_ERROR,
  REMOVE_CONTACTMOMENT_STAKEHOLDER: GENERIC_ERROR,
  SEARCH_ADMIN_SCHOOLS: GENERIC_ERROR,
  GET_ALL_SCHOOLS: GENERIC_ERROR,
  NO_PERMISSION: 'NP'
};

const generic = (resp) => {
  if (resp.status !== 200) {
    throw new Error(GENERIC_ERROR);
  }
};

const updateOverview = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_OVERVIEW);
  }
};

const dossierCreate = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.DOSSIER_CREATE);
  }
};

const dossierStatusChange = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.DOSSIER_STATUS_CHANGE);
  }
};

const dossierPrivateModeChange = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.DOSSIER_PRIVATE_MODE_CHANGE);
  }
};

const dossierDeadlineChange = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.DOSSIER_DEADLINE_CHANGE);
  }
};

const dossierAssignedChange = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.DOSSIER_ASSIGNED_CHANGE);
  }
};

const dossierRelateDossiers = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.DOSSIER_RELATE_DOSSIERS);
  }
};

const dossierRemoveRelations = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DOSSIER_REMOVE_RELATIONS);
  }
};

const approveClarification = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.APPROVE_CLARIFICATION);
  }
};

const updateClarification = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_CLARIFICATION);
  }
};

const addClarification = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_CLARIFICATION);
  }
};

const deleteClarification = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_CLARIFICATION);
  }
};

const addClarificationStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_CLARIFICATION_STAKEHOLDER);
  }
};

const updateClarificationStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_CLARIFICATION_STAKEHOLDER);
  }
};

const removeClarificationStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.REMOVE_CLARIFICATION_STAKEHOLDER);
  }
};

const addCasetafelStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_CASETAFEL_STAKEHOLDER);
  }
};

const updateCasetafelStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_CASETAFEL_STAKEHOLDER);
  }
};

const removeCasetafelStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.REMOVE_CASETAFEL_STAKEHOLDER);
  }
};

const addProcedureStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_PROCEDURE_STAKEHOLDER);
  }
};

const updateProcedureStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_PROCEDURE_STAKEHOLDER);
  }
};

const removeProcedureStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.REMOVE_PROCEDURE_STAKEHOLDER);
  }
};

const updateCasetafel = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_CASETAFEL);
  }
};

const addCasetafel = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_CASETAFEL);
  }
};

const deleteCasetafel = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_CASETAFEL);
  }
};

const approveCasefafel = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.APPROVE_CASETAFEL);
  }
};

const rejectCasetafel = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.REJECT_CASETAFEL);
  }
};

const deleteForDossier = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_ATTACHMENT);
  }
};

const updateForDossier = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_ATTACHMENT);
  }
};

const uploadForDossier = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPLOAD_ATTACHMENT);
  }
};

const getFormBySlug = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_FORM_BY_SLUG);
  }
};

const exportCasetafelAnswers = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.EXPORT_CASETAFEL_ANSWERS);
  }
};

const updateProcedure = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_PROCEDURE);
  }
};

const addProcedurePart = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_PROCEDURE_PART);
  }
};

const updateProcedurePart = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_PROCEDURE_PART);
  }
};

const deleteProcedurePart = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_PROCEDURE_PART);
  }
};

const addProcedureGoal = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_PROCEDURE_GOAL);
  }
};

const updateProcedureGoal = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_PROCEDURE_GOAL);
  }
};

const deleteProcedureGoal = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_PROCEDURE_GOAL);
  }
};

const addProcedureGoalIndicator = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_PROCEDURE_GOAL);
  }
};

const updateProcedureGoalIndicator = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_PROCEDURE_GOAL);
  }
};

const deleteProcedureGoalIndicator = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_PROCEDURE_GOAL);
  }
};

const addIndicatorMeasureMoment = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_INDICATOR_MEASURE_MOMENT);
  }
};

const updateIndicatorMeasureMoment = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_INDICATOR_MEASURE_MOMENT);
  }
};

const deleteIndicatorMeasureMoment = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.DELETE_INDICATOR_MEASURE_MOMENT);
  }
};

const addComment = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_COMMENT);
  }
};

const updateComment = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_COMMENT);
  }
};

const deleteComment = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.DELETE_COMMENT);
  }
};

const pinComment = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.PIN_COMMENT);
  }
};

const unpinComment = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UNPIN_COMMENT);
  }
};

const addOffering = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_OFFERING);
  }
};

const updateOffering = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_OFFERING);
  }
};

const deleteOffering = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_OFFERING);
  }
};

const deleteOfferingImage = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_OFFERING_IMAGE);
  }
};

const addOfferingImage = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_OFFERING_IMAGE);
  }
};

const getAllThemes = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_ALL_THEMES);
  }
};

const addTheme = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_THEME);
  }
};

const updateTheme = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_THEME);
  }
};

const removeTheme = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.REMOVE_THEME);
  }
};

const getContactsWithoutParents = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_CONTACTS_WITHOUT_PARENTS);
  }
};

const addContact = (resp) => {
  if (resp.status !== 201) {
    if (resp?.json?.extraInfo?.code === ERROR_CODES_SPO.CONTACT_WITH_EMAIL_EXISTS) {
      throw new Error(ERROR_TEXTS.CONTACT_WITH_EMAIL_EXISTS);
    }
    if (resp?.json?.extraInfo?.code === ERROR_CODES_SPO.CONTACT_WITH_NO_PERMISSION) {
      throw new Error(ERROR_TEXTS.CONTACT_WITH_NO_PERMISSION);
    }
    throw new Error(ERROR_TEXTS.ADD_CONTACT);
  }
};

const updateContact = (resp) => {
  if (resp.status !== 200) {
    if (resp?.json?.extraInfo?.code === ERROR_CODES_SPO.CONTACT_WITH_EMAIL_EXISTS) {
      throw new Error(ERROR_TEXTS.CONTACT_WITH_EMAIL_EXISTS);
    }
    if (resp?.json?.extraInfo?.code === ERROR_CODES_SPO.CONTACT_WITH_NO_PERMISSION) {
      throw new Error(ERROR_TEXTS.CONTACT_WITH_NO_PERMISSION);
    }
    throw new Error(ERROR_TEXTS.UPDATE_CONTACT);
  }
};
const updateContactRole = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_CONTACT_ROLE);
  }
};
const createContactRole = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_CONTACT_ROLE);
  }
};
const deleteContactRole = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.UPDATE_CONTACT_ROLE);
  }
};

const removeContact = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.REMOVE_CONTACT);
  }
};

const getSchool = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_SCHOOL);
  }
};

const addSchool = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_SCHOOL);
  }
};

const updateSchool = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_SCHOOL);
  }
};

const deleteSchool = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_SCHOOL);
  }
};

const getBranch = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_BRANCH);
  }
};

const addBranch = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.ADD_BRANCH);
  }
};

const updateBranch = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_BRANCH);
  }
};

const deleteBranch = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_BRANCH);
  }
};

const updateAgodiBranch = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_AGODI_BRANCH);
  }
};

const setSchoolVisible = (resp) => {
  if (resp.status !== 204) {
    throw new Error(GENERIC_ERROR);
  }
};
const setSchoolInvisible = (resp) => {
  if (resp.status !== 204) {
    throw new Error(GENERIC_ERROR);
  }
};
const setBranchVisible = (resp) => {
  if (resp.status !== 204) {
    throw new Error(GENERIC_ERROR);
  }
};

const setBranchInvisible = (resp) => {
  if (resp.status !== 204) {
    throw new Error(GENERIC_ERROR);
  }
};

const submitFirstTimeSetup = (resp) => {
  if (resp.status !== 201) {
    throw new Error(GENERIC_ERROR);
  }
};

const getNotApprovedCount = (resp) => {
  if (resp.status !== 200) {
    throw new Error(GENERIC_ERROR);
  }
};

const approveBulk = (resp) => {
  if (resp.status !== 200) {
    throw new Error(GENERIC_ERROR);
  }
};

const addTemplate = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_TEMPLATE);
  }
};

const updateTemplate = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_TEMPLATE);
  }
};

const deleteTemplate = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.DELETE_TEMPLATE);
  }
};

const getTemplatesForCategory = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_TEMPLATES_FOR_CATEGORY);
  }
};

const addPartner = (resp) => {
  if (resp.status !== 201) {
    if (resp?.json?.extraInfo?.code === ERROR_CODES_SPO.CONTACT_WITH_NAME_EXISTS) {
      throw new Error(ERROR_TEXTS.PARTNER_WITH_NAME_EXISTS);
    }
    throw new Error(ERROR_TEXTS.ADD_PARTNER);
  }
};

const updatePartner = (resp) => {
  if (resp.status !== 200) {
    if (resp?.json?.extraInfo?.code === ERROR_CODES_SPO.CONTACT_WITH_NAME_EXISTS) {
      throw new Error(ERROR_TEXTS.PARTNER_WITH_NAME_EXISTS);
    }
    throw new Error(ERROR_TEXTS.UPDATE_PARTNER);
  }
};

const removePartner = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.REMOVE_PARTNER);
  }
};

const getAllPartners = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_ALL_PARTNERS);
  }
};

const updateContactmoment = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_CONTACTMOMENT);
  }
};

const addContactmoment = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_CONTACTMOMENT);
  }
};

const deleteContactmoment = (resp) => {
  if (resp.status !== 204) {
    throw new Error(ERROR_TEXTS.REMOVE_CONTACTMOMENT);
  }
};
const updateContactmomentStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.UPDATE_CONTACTMOMENT_STAKEHOLDER);
  }
};

const addContactmomentStakeholder = (resp) => {
  if (resp.status !== 201) {
    throw new Error(ERROR_TEXTS.ADD_CONTACTMOMENT_STAKEHOLDER);
  }
};

const deleteContactmomentStakeholder = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.REMOVE_CONTACTMOMENT_STAKEHOLDER);
  }
};

const searchAdminSchools = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.SEARCH_ADMIN_SCHOOLS);
  }
};

const getAllSchools = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_ALL_SCHOOLS);
  }
};

const getCityContactsWithoutParents = (resp) => {
  if (resp.status !== 200) {
    throw new Error(ERROR_TEXTS.GET_CONTACTS);
  }
};
const updateContactAndRoles = (resp) => {
  if (resp.includes(403)) {
    throw new Error(ERROR_TEXTS.NO_PERMISSION);
  }
  if (resp.includes(400)) {
    throw new Error(GENERIC_ERROR);
  }
  if (resp.length === 1 && !resp.includes(200)) {
    throw new Error(ERROR_TEXTS.UPDATE_CONTACT);
  }
};

const responseValidators = {
  generic,
  dossierCreate,
  dossierStatusChange,
  dossierPrivateModeChange,
  dossierDeadlineChange,
  dossierAssignedChange,
  dossierRelateDossiers,
  dossierRemoveRelations,
  approveClarification,
  addClarification,
  updateClarification,
  deleteClarification,
  addClarificationStakeholder,
  updateClarificationStakeholder,
  removeClarificationStakeholder,
  addCasetafelStakeholder,
  updateCasetafelStakeholder,
  removeCasetafelStakeholder,
  addProcedureStakeholder,
  updateProcedureStakeholder,
  removeProcedureStakeholder,
  addCasetafel,
  updateCasetafel,
  deleteCasetafel,
  approveCasefafel,
  rejectCasetafel,
  deleteForDossier,
  updateForDossier,
  uploadForDossier,
  getFormBySlug,
  exportCasetafelAnswers,
  updateProcedure,
  addProcedurePart,
  updateProcedurePart,
  deleteProcedurePart,
  addProcedureGoal,
  updateProcedureGoal,
  deleteProcedureGoal,
  addProcedureGoalIndicator,
  updateProcedureGoalIndicator,
  deleteProcedureGoalIndicator,
  addIndicatorMeasureMoment,
  updateIndicatorMeasureMoment,
  deleteIndicatorMeasureMoment,
  addComment,
  updateComment,
  deleteComment,
  pinComment,
  unpinComment,
  addOffering,
  updateOffering,
  deleteOffering,
  deleteOfferingImage,
  addOfferingImage,
  addTheme,
  updateTheme,
  removeTheme,
  addContact,
  updateContact,
  removeContact,
  getSchool,
  addSchool,
  updateSchool,
  deleteSchool,
  getBranch,
  addBranch,
  updateBranch,
  deleteBranch,
  updateAgodiBranch,
  setSchoolVisible,
  setSchoolInvisible,
  setBranchVisible,
  setBranchInvisible,
  submitFirstTimeSetup,
  getNotApprovedCount,
  approveBulk,
  addTemplate,
  updateTemplate,
  deleteTemplate,
  getTemplatesForCategory,
  addPartner,
  updatePartner,
  removePartner,
  getAllPartners,
  addContactmoment,
  updateContactmoment,
  deleteContactmoment,
  addContactmomentStakeholder,
  updateContactmomentStakeholder,
  deleteContactmomentStakeholder,
  searchAdminSchools,
  getContactsWithoutParents,
  getAllThemes,
  getAllSchools,
  getCityContactsWithoutParents,
  updateOverview,
  updateContactRole,
  createContactRole,
  deleteContactRole,
  updateContactAndRoles
};

export default responseValidators;
